import {
  BookOutlined,
  FileImageOutlined,
  MenuUnfoldOutlined,
  ProjectOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { AdminLayout } from "layouts/AdminLayout";
import React from "react";
import { NotFoundPage } from "views/404/NotFoundPage";
import { BannerPage } from "views/Banner/BannerPage";
import { DocumentPage } from "views/Document/DocumentPage";
import LoginPage from "views/Login/LoginPage";
import { ProfilePage } from "views/Profile/ProfilePage";
import { ProjectPage } from "views/Project/Project";
import { RolePage } from "views/Role/RolePage";
import { StaffPage } from "views/Staff/StaffPage";

export interface AppRoute {
  path?: string;
  index?: boolean;
  element?: React.ReactNode;
  name?: string;
  title?: string;
  children?: AppRoute[];
  icon?: React.ReactNode;
  breadcrumb?: string;
  isAccess?: boolean;
  hidden?: boolean;
  checkIsDev?: boolean;
  description?: string;
}

export type Route = AppRoute;

export const adminRoutes: AppRoute[] = [
  {
    title: "Dự án",
    icon: <ProjectOutlined />,
    path: "/project",
    children: [
      {
        title: "Xem danh sách dự án",
        name: "danh-sach-du-an",
        path: "danh-sach-du-an",
        breadcrumb: "Xem danh sách dự án",
        element: <ProjectPage title="Danh sách dự án" />,
      },
      {
        title: "Chi tiết dự án",
        name: "chi-tiet-du-an",
        path: "chi-tiet-du-an",
        breadcrumb: "Chi tiết dự án",
        element: null,
        hidden: true,
      },
      {
        title: "Chỉnh sửa dự án",
        name: "chinh-sua-du-an",
        path: "chinh-sua-du-an",
        breadcrumb: "Chỉnh sửa dự án",
        element: null,
        hidden: true,
      },
      {
        title: "Xóa dự án",
        name: "xoa-du-an",
        path: "xoa-du-an",
        breadcrumb: "Xóa dự án",
        element: null,
        hidden: true,
      },
    ],
  },
  {
    title: "Tài liệu",
    icon: <BookOutlined />,
    path: "/document",
    children: [
      {
        title: "Xem Tài liệu",
        name: "danh-sach-tai-lieu",
        path: "danh-sach-tai-lieu",
        breadcrumb: "Danh sách tài liệu",
        element: <DocumentPage title="Danh sách tài liệu" />,
      },
      {
        title: "Chỉnh sửa tài liệu",
        name: "chinh-sua-tai-lieu",
        path: "chinh-sua-tai-lieu",
        breadcrumb: "Chỉnh sửa tài liệu",
        element: null,
        hidden: true,
      },
      {
        title: "Xóa tài liệu",
        name: "xoa-tai-lieu",
        path: "xoa-tai-lieu",
        breadcrumb: "Xóa tài liệu",
        element: null,
        hidden: true,
      },
      {
        title: "Download tài liệu",
        name: "download-tai-lieu",
        path: "download-tai-lieu",
        breadcrumb: "Download tài liệu",
        element: null,
        hidden: true,
      },
    ],
  },
  {
    title: "Banner",
    icon: <FileImageOutlined />,
    element: <BannerPage title="Banner" />,
    path: "/banner",
  },
  {
    title: "Nhân viên",
    icon: <TeamOutlined />,
    element: <StaffPage title="Nhân viên" />,
    path: "/staff",
    children: [
      {
        title: "Xem danh sách nhân viên",
        name: "danh-sach-nhan-vien",
        path: "danh-sach-nhan-vien",
        breadcrumb: "Xem danh sách nhân viên",
        element: <StaffPage title="Danh sách nhân viên" />,
      },
      {
        title: "Chỉnh sửa nhân viên",
        name: "chinh-sua-nhan-vien",
        path: "chinh-sua-nhan-vien",
        breadcrumb: "Chỉnh sửa nhân viên",
        element: null,
        hidden: true,
      },
      {
        title: "Xóa nhân viên",
        name: "xoa-nhan-vien",
        path: "xoa-nhan-vien",
        breadcrumb: "Xóa nhân viên",
        element: null,
        hidden: true,
      },
      {
        title: "Khóa/mở nhân viên",
        name: "khoa-mo-nhan-vien",
        path: "khoa-mo-nhan-vien",
        breadcrumb: "Khóa/mở nhân viên",
        element: null,
        hidden: true,
      },
      {
        title: "Reset mật khẩu",
        name: "reset-mat-khau",
        path: "reset-mat-khau",
        breadcrumb: "Reset mật khẩu",
        element: null,
        hidden: true,
      },
    ],
  },
  {
    title: "Vai trò",
    icon: <MenuUnfoldOutlined />,
    element: <RolePage title="Vai trò" />,
    path: "/role",
  },
  {
    title: "Cá nhân",
    icon: <UserOutlined />,
    path: "/profile",
    element: <ProfilePage title="Cá nhân" />,
  },
];

const routes: AppRoute[] = [
  {
    path: "/",
    element: <AdminLayout />,
    children: adminRoutes,
  },
  {
    path: "/login",
    element: <LoginPage title="Đăng nhập" />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export { routes };
